import React from 'react'
import { Redirect } from 'react-router'
import classNames from 'classnames'

import NavBar from 'components/NavBar'
import { useQuery } from 'components/graphql'
import { prepareFormData } from 'components/SectionHandler/helpers/data'
import appStyles from 'style/app.module.scss'

const GlobalCashRegistersHandler = (props) => {
	const { sectionData: { itemQuery, subsections, label }, subsectionData: { subsectionQuery, fields, updateMutation, component: Subsection }, handleMutation, location } = props
	const dataQuery = subsectionQuery || itemQuery
	const handleUpdate = (data, options = {}) => {
		return handleMutation({
			mutation: options.mutation || updateMutation,
			variables: { fields: data },
			...options
		})
	}

	const isRedirect = !Subsection
	const { data = {}, loading, queryField } = useQuery(dataQuery, { skip: isRedirect })
	if(isRedirect) {
		const redirectSubSection = subsections?.[0]?.link || ''
		return <Redirect to={`${location.pathname}/${redirectSubSection}`} />
	}
	const isLoading = !Object.keys(data).length && loading
	const formData = prepareFormData(data[queryField], fields)

	return(
		<NavBar
			label={label}
			navContent={subsections}
			getLink={l => `${props.baseUrl ? '/' + props.baseUrl : ''}/${props.section}${l ? '/' + l : ''}`}
			subNav={true}
		>
			<div className={classNames(appStyles.itemView, appStyles['flex-cols'])}>
				{Subsection ?
					<Subsection
						key={isLoading}
						{...props}
						formData={formData}
						isLoading={isLoading}
						className={classNames({ [appStyles.loading]: isLoading })}
						onUpdate={handleUpdate} />
					: 'No data to display'
				}
			</div>
		</NavBar>
	)
}

export default GlobalCashRegistersHandler
